import {CdnImageFactors, CdnImageSizes} from '@config/cdnImageSizes';

export const DEFAULT_SIZE_MULTIPLIER = 2;

export const generateCdnImageSrc = <T extends string | undefined | null>(
    src: T,
    options: (
        | {
              size: keyof typeof CdnImageSizes;
              focusPositionX?: undefined;
              focusPositionY?: undefined;
          }
        | {
              size: keyof typeof CdnImageSizes | undefined;
              focusPositionX: number | null | undefined;
              focusPositionY: number | null | undefined;
          }
    ) & {sizeMultiplier?: (typeof CdnImageFactors)[number]},
) => {
    const {size, focusPositionX, focusPositionY, sizeMultiplier} = options;

    const multiplier = sizeMultiplier || DEFAULT_SIZE_MULTIPLIER;

    const constructSrc = (multiplier = 1) => {
        const [width, height] =
            size && size in CdnImageSizes ? CdnImageSizes[size] : [0, 0];

        try {
            if (typeof src !== 'string') {
                console.warn('Invalid image source:', src);
                return src;
            }

            const queryParams: string[] = [];

            let url: string = src;

            if (width) {
                queryParams.push(`width=${Math.floor(+width * multiplier)}`);
            }
            if (height) {
                queryParams.push(`height=${Math.floor(+height * multiplier)}`);
            }
            if (focusPositionX !== undefined && focusPositionX !== null) {
                queryParams.push(`focusPositionX=${focusPositionX}`);
            }
            if (focusPositionY !== undefined && focusPositionY !== null) {
                queryParams.push(`focusPositionY=${focusPositionY}`);
            }

            if (queryParams.length > 0) {
                url += '?' + queryParams.join('&');
            }

            return url as T;
        } catch (error) {
            throw new Error(`Invalid image source: ${src}; error: ${error}`);
        }
    };

    const srcSet = CdnImageFactors.filter(factor => factor !== 1)
        .map(factor => {
            return `${constructSrc(factor)} ${factor}x`;
        })
        .join(', ');

    return {
        src: constructSrc(1),
        src2x: constructSrc(multiplier),
        srcSet,
    };
};
